/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SmartSmsStatus {
  Stored = 1,
  Done = 2,
  Waiting = 3,
  NotFound = 4,
  Failed = 5,
  Unknown = 6,
  InternalError = 7,
  CellDoesNotExist = 8,
  GatewayError = 9,
  EagleError = 10
}
